// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__9bYQW","modal_title":"BackgroundModal_modal_title__+9OQd","modal_text":"BackgroundModal_modal_text__ZBPJ3"};